import {cn} from '@bem-react/classname';
import {UseFormProps} from 'react-hook-form';

export const formSettings: UseFormProps = {
    mode: 'onBlur',
    shouldUnregister: false,
};

export const cnSurveyPage = cn('SurveyPage');

export const {preview, iframe, routes, mobile} = window.YC;

export const embedScriptUrl = 'https://yastatic.net/s3/frontend/forms/_/embed.js';
